<template>
  <div>
    <CompaniesList listStatus="pending" />
  </div>
</template>

<script>

import CompaniesList from "@/components/Company/CompaniesList";
export default {
  name: "TodoCompany",
  components: {
    CompaniesList
  },
  data(){
    return {
      updateCompany: false
    }
  },
  methods:{

  },
  created(){
  }
}
</script>

<style scoped>

</style>
